import { render, staticRenderFns } from "./SvgCircle.vue?vue&type=template&id=64dd3bc5&scoped=true&"
import script from "./SvgCircle.vue?vue&type=script&lang=ts&"
export * from "./SvgCircle.vue?vue&type=script&lang=ts&"
import style0 from "./SvgCircle.vue?vue&type=style&index=0&id=64dd3bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd3bc5",
  null
  
)

export default component.exports